<span
  class="check-container"
  [style.backgroundColor]="circleColor()"
  ><app-icon-check></app-icon-check>
</span>
